/**
 * Why the last session ended, carried across the reload to the login screen.
 *
 * `sessionStorage` and not Redux: the session ends with a full page load, which
 * rebuilds the store, and the tab is the right lifetime for "your session
 * expired" — another tab, or tomorrow, should not say it.
 */
export const SESSION_END_REASON_KEY = 'auth:endReason';

export const SESSION_END_REASON = {
  EXPIRED: 'expired',
};

/** @returns {string|null} */
export const readSessionEndReason = () => {
  try {
    return window.sessionStorage.getItem(SESSION_END_REASON_KEY);
  } catch {
    return null;
  }
};

/**
 * Forgets the reason, so a later visit to the login does not repeat it. Kept
 * apart from the read because React may run a state initializer twice.
 */
export const clearSessionEndReason = () => {
  try {
    window.sessionStorage.removeItem(SESSION_END_REASON_KEY);
  } catch {
    // Nothing to forget.
  }
};
